import { __extends } from "tslib";
import { DeleteDocumentClassifierRequest, DeleteDocumentClassifierResponse } from "../models/index";
import { deserializeAws_json1_1DeleteDocumentClassifierCommand, serializeAws_json1_1DeleteDocumentClassifierCommand, } from "../protocols/Aws_json1_1";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
var DeleteDocumentClassifierCommand = /** @class */ (function (_super) {
    __extends(DeleteDocumentClassifierCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function DeleteDocumentClassifierCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    DeleteDocumentClassifierCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var handlerExecutionContext = {
            logger: logger,
            inputFilterSensitiveLog: DeleteDocumentClassifierRequest.filterSensitiveLog,
            outputFilterSensitiveLog: DeleteDocumentClassifierResponse.filterSensitiveLog,
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    DeleteDocumentClassifierCommand.prototype.serialize = function (input, context) {
        return serializeAws_json1_1DeleteDocumentClassifierCommand(input, context);
    };
    DeleteDocumentClassifierCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_json1_1DeleteDocumentClassifierCommand(output, context);
    };
    return DeleteDocumentClassifierCommand;
}($Command));
export { DeleteDocumentClassifierCommand };
//# sourceMappingURL=DeleteDocumentClassifierCommand.js.map